import { axios } from '@/utils/request'

const api = {
  customerList: '/badminapi/customer/customerlist',
  customerEdit: '/badminapi/customer/customerEdit',
  customerDetail: '/badminapi/customer/customerDetail',
  groupList: '/badminapi/customer/groupList',
  groupOptions: '/badminapi/customer/groupOptions',
  groupDetail: '/badminapi/customer/groupDetail',
  groupAdd: '/badminapi/customer/groupAdd',
  groupEdit: '/badminapi/customer/groupEdit',
  groupDelete: '/badminapi/customer/groupDelete',
  tagsList: '/badminapi/customer/tagsList',
  tagsOptions: '/badminapi/customer/tagsOptions',
  tagsDetail: '/badminapi/customer/tagsDetail',
  tagsAdd: '/badminapi/customer/tagsAdd',
  tagsEdit: '/badminapi/customer/tagsEdit',
  tagsDelete: '/badminapi/customer/tagsDelete',
  goodsOptions: '/badminapi/customer/goodsOptions',
}

export default api

export function customerDetail(parameter) {
  return axios({
    url: api.customerDetail,
    method: 'get',
    params: parameter
  })
}
export function customerEdit(parameter) {
  return axios({
    url: api.customerEdit,
    method: 'get',
    params: parameter
  })
}
export function customerList(parameter) {
  return axios({
    url: api.customerList,
    method: 'get',
    params: parameter
  })
}
export function groupList(parameter) {
  return axios({
    url: api.groupList,
    method: 'get',
    params: parameter
  })
}
export function groupOptions(parameter) {
  return axios({
    url: api.groupOptions,
    method: 'get',
    params: parameter
  })
}
export function groupDetail(parameter) {
  return axios({
    url: api.groupDetail,
    method: 'get',
    params: parameter
  })
}
export function groupAdd(parameter) {
  return axios({
    url: api.groupAdd,
    method: 'get',
    params: parameter
  })
}
export function groupEdit(parameter) {
  return axios({
    url: api.groupEdit,
    method: 'get',
    params: parameter
  })
}
export function groupDelete(parameter) {
  return axios({
    url: api.groupDelete,
    method: 'get',
    params: parameter
  })
}



export function tagsList(parameter) {
  return axios({
    url: api.tagsList,
    method: 'get',
    params: parameter
  })
}
export function tagsOptions(parameter) {
  return axios({
    url: api.tagsOptions,
    method: 'get',
    params: parameter
  })
}
export function tagsDetail(parameter) {
  return axios({
    url: api.tagsDetail,
    method: 'get',
    params: parameter
  })
}
export function tagsAdd(parameter) {
  return axios({
    url: api.tagsAdd,
    method: 'get',
    params: parameter
  })
}
export function tagsEdit(parameter) {
  return axios({
    url: api.tagsEdit,
    method: 'get',
    params: parameter
  })
}
export function tagsDelete(parameter) {
  return axios({
    url: api.tagsDelete,
    method: 'get',
    params: parameter
  })
}

export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}